export default __webpack_public_path__ + "static/media/clarinet_five.42b49b85.mp3";